export default function staticInitializable(
  slice,
  initializeActionType,
  initialValue = {},
) {
  return function boundStaticInitializable(state = initialValue, action) {
    if (action.type === initializeActionType.toString()) {
      return action.payload[slice];
    }
    return state;
  };
}
